import { editFlowTask } from '~src/app/actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '~src/app/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '~src/flow/utils/FlowTaskActionUtils';
import { RunFlowTaskInfo } from '~src/ts/models/RunFlowTaskInfo';

import { EntityActionNames, IEntityAction } from './IEntityAction';


export const EditFlowTaskAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.editTask_action,
  isVisible: (targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length === 1 && userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => editFlowTask(targetItems)
};
